import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { AbsoluteRightTopWrapper } from 'wrappers';
import { Icon, Bullet } from 'atoms';

const template = styled.div`
  position: relative;
  cursor: pointer;
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'NotesIcon',
      displayValue: ({ icon }) => icon
    },
    {
      component: wrap(Bullet, AbsoluteRightTopWrapper),
      name: 'Notification',
      renderIf: ({ displayNotification }) => displayNotification,
      displayValue: ({ }) => '',
      displayState: ({ }) => ({ color: window?.settings?.primary_color ?? '#1DBD6B', size: '9px' })
    }
  ],
})
